import { Box } from '@mui/material';
import React from 'react';
import { StyledHeader, SubText } from './styled';
import type { Section } from '../HomePage/types';

const AdminAuthSections = ({
  title,
  subtext,
  titleStyle: TitleComponent,
  subtextStyle: SubtextComponent
}: Section) => (
  <Box marginBottom={2}>
    {title &&
      (TitleComponent ? (
        <TitleComponent>{title}</TitleComponent>
      ) : (
        <StyledHeader component='div'>{title}</StyledHeader>
      ))}
    {subtext &&
      (SubtextComponent ? (
        <SubtextComponent component='div'>{subtext}</SubtextComponent>
      ) : (
        <SubText align='left'>{subtext}</SubText>
      ))}
  </Box>
);
export default AdminAuthSections;
